/**
 * @jest-environment jsdom
 */
import { UIHeading5 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as style from './style.css';

export interface INavigationProps {
  active: boolean;
  fixed: boolean;
  transition: boolean;
  description: string;
  showRightContent: boolean;
  navigateLinks: React.ReactElement;
  favoriteButton: React.ReactElement;
  sharingButton: React.ReactElement;
}

export const Navigation: React.FC<INavigationProps> = ({
  active,
  fixed,
  transition,
  description,
  showRightContent,
  navigateLinks,
  favoriteButton,
  sharingButton,
}) => {
  return (
    <div
      data-testid="FixedNavigation"
      data-navigation-type={fixed ? 'fixed' : 'static'}
      className={cn(
        style['container'],
        fixed && style['fixed'],
        fixed && active && style['active'],
        fixed && transition && style['transition'],
      )}
    >
      <div className={style['wrapper']}>
        {navigateLinks}

        {showRightContent && (
          <div className={style['aside']}>
            <UIHeading5 color="black_100">{description}</UIHeading5>

            <div className={style['buttons']}>
              <div className={style['button']}>{favoriteButton}</div>
              <div className={style['button']}>{sharingButton}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
